import { render, staticRenderFns } from "./excursions-header.vue?vue&type=template&id=e1119458&"
import script from "./excursions-header.vue?vue&type=script&lang=ts&"
export * from "./excursions-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports